import React, { useEffect } from 'react';
import './Toast.css';

function Toast({ message, onClose, variant = 'success' }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000); // Auto-close after 3 seconds

    return () => clearTimeout(timer);
  }, [onClose]);

  // Only allow known variants through so a typo in a call site can't
  // produce an unstyled toast.
  const safeVariant = variant === 'warning' ? 'warning' : 'success';

  return (
    <div className="toast">
      <div className={`toast-content toast-${safeVariant}`}>
        <span className="toast-message">{message}</span>
        <button className="toast-close" onClick={onClose}>×</button>
      </div>
    </div>
  );
}

export default Toast; 